import { UPDATE_ACTIONABLE_SETTING } from '../../constant';

const updateActionableSettings = (data) => ({
  type: UPDATE_ACTIONABLE_SETTING,
  data,
});

export { updateActionableSettings };
